// Module
var code = "<generic-modal-container on-close=\"$ctrl.close()\"> <generic-form header=\"$ctrl.header\" subheader=\"$ctrl.subheader\" submit-button-text=\"$ctrl.submitButtonText\" fields-list=\"$ctrl.fieldsList\" on-submit=\"$ctrl.submit(form)\" on-close=\"$ctrl.close()\"> </generic-form> </generic-modal-container> ";
// Exports
module.exports = code;